import { RequestType } from '../../../Service/RequestType';
import { callService } from '../../../Service/ServiceBase';
import { PagedData } from '../../Common/CommonModel';
import { AzureSearchService } from './Model/AzureSearchServiceModel';

class AzureSearchServiceService {
  async getAzureSearchServices(): Promise<PagedData<AzureSearchService>> {
    const pagedAzureSearchServiceResult = await callService(
      'AzureSearchService',
      '',
      RequestType.GET,
    );
    return pagedAzureSearchServiceResult;
  }

  async canDeleteAzureSearchService(
    AzureSearchService: string,
  ): Promise<boolean> {
    return await callService(
      'AzureSearchService',
      `candelete/${AzureSearchService}`,
      RequestType.GET,
    );
  }

  async setAzureSearchService(
    azureSearchService: AzureSearchService,
  ): Promise<AzureSearchService> {
    const AzureSearchService = await callService(
      'AzureSearchService',
      `${azureSearchService.Name}`,
      RequestType.PUT,
      azureSearchService,
    );
    return AzureSearchService;
  }

  async getAzureSearchService(name: string): Promise<AzureSearchService> {
    const AzureSearchService = await callService(
      'AzureSearchService',
      `${name}`,
      RequestType.GET,
    );
    return AzureSearchService;
  }

  async deleteAzureSearchService(name: string): Promise<AzureSearchService> {
    const AzureSearchService = await callService(
      'AzureSearchService',
      `${name}`,
      RequestType.DELETE,
    );
    return AzureSearchService;
  }
}

export const azureSearchServiceService: AzureSearchServiceService =
  new AzureSearchServiceService();
